import axios from "axios";
import { API } from "../utilities/api.config";

function createClient(clientData) {
  return (dispatch) => {
    dispatch({
      type: "CLIENT_CREATE_REQUESTED",
    });
    axios
      .post(API.CREATE_CLIENTS, clientData, {
        headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
      })
      .then((response) => {
        dispatch({
          type: "CLIENT_CREATE_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "CLIENT_CREATE_FAIL",
          payload: error,
        });
        if (error.response.status === 401) {
          dispatch({
            type: "LOGOUT",
          });
        }
      });
  };
}

function updateClient(householdId, payload = {}) {
  return (dispatch) => {
    dispatch({
      type: "CLIENTS_UPDATE_REQUESTED",
    });

    axios
      .patch(`${API.UPDATE_CLIENTS}/${householdId}`, payload, {
        headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
      })
      .then((response) => {
        dispatch({
          type: "CLIENT_UPDATE_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "CLIENT_UPDATE_FAIL",
          payload: error,
        });
        if (error.response.status === 401) {
          dispatch({
            type: "LOGOUT",
          });
        }
      });
  };
}

function updateAdvisorConfig(payload) {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_ADVISOR_CONFIG",
      payload: payload,
    });
  };
}

function getClients() {
  return (dispatch) => {
    dispatch({
      type: "GET_CLIENTS_REQUESTED",
    });
    axios
      .get(API.GET_HOUSEHOLDS)
      .then((response) => {
        const payload = response.data;
        dispatch({
          type: "GET_CLIENTS",
          payload,
        });
        dispatch({
          type: "GET_CLIENTS_SUCCESS",
        });
        return payload;
      })
      .catch((error) => {
        dispatch({
          type: "GET_CLIENTS_FAIL",
        });
      });
  };
}

export const clientAction = {
  createClient,
  updateClient,
  updateAdvisorConfig,
  getClients,
};

export default clientAction;



// WEBPACK FOOTER //
// ./src/actions/client.action.js